import { getSmallestPagePreviewUrl } from 'approot/lesson/lesson.utils';
import { ASSESSMENT, LESSON, WORKSHEET } from 'global/constants';
import { ContentPageHeading18 } from 'approot/shared/content-page/content-page.style';
import { LessonPrintablesFragment_printableAnswerSheet } from '../lesson-printables/__generated__/LessonPrintablesFragment';
import WorksheetCard from 'approot/shared/worksheet-card/worksheet-card';
import { generateWorksheetDataAttributes } from 'approot/lesson/sheets.utils';
import { EVENT_CATEGORY_ANSWER_SHEET } from 'approot/shared/data-tracker/data-events.constants';
import { useImageRatio } from 'approot/shared/images/image-ratio.hooks';
import {
  ContentCardCol,
  ContentCardRow,
} from 'approot/shared/content/content-row.style';
import { AssessmentWorksheetsFragment_answerSheet } from 'approot/assessment/sections/worksheets/__generated__/AssessmentWorksheetsFragment';

type Props = {
  contentId: number;
  contentType: typeof LESSON | typeof ASSESSMENT;
  printableAnswerSheet:
    | LessonPrintablesFragment_printableAnswerSheet
    | AssessmentWorksheetsFragment_answerSheet;
};

const PreviousPrintables = ({
  contentId,
  contentType,
  printableAnswerSheet,
}: Props) => {
  const answerSheetImageProperties = useImageRatio(
    getSmallestPagePreviewUrl(printableAnswerSheet?.document)
  );

  return (
    <>
      <ContentPageHeading18 data-selector="content-section-title">
        Printables
      </ContentPageHeading18>

      <ContentCardRow>
        <ContentCardCol>
          <WorksheetCard
            {...generateWorksheetDataAttributes(
              {
                id: contentId,
                type: contentType,
              },
              EVENT_CATEGORY_ANSWER_SHEET,
              1,
              printableAnswerSheet.document?.individualPages?.map(
                (_, i) => i + 1
              ) || [],
              true
            )}
            isBookmarkable={false}
            link={printableAnswerSheet.document?.downloadURL || undefined}
            title="Answers"
            // if sheet ratios haven't been determined yet, don't pass image urls to prevent image requests of the wrong size.
            images={
              answerSheetImageProperties.ratio
                ? printableAnswerSheet.document?.individualPages?.[0]
                    ?.pagesPreview
                : undefined
            }
            imageRatio={answerSheetImageProperties.ratio}
            type={WORKSHEET}
          />
        </ContentCardCol>
      </ContentCardRow>
    </>
  );
};

export default PreviousPrintables;
